<template>
    <div class="footer">
        <!-- <div class="footer-content">{{ $t('请加入社交媒体信息') }}TWITTER,MEDIUM,TG，{{ $t('联系我们') }}，{{ $t('版权所有（公司）') }}</div>
        <div class="footer-content">{{ $t('联系我们的邮件请填写') }}：neco.ltd@outlook.com</div> -->
        <div class="footer-left">
            <div class="img-box">
                <img
                    v-for="(item, index) in iconList"
                    :key="index"
                    :src="item.icon"
                    @click="openLink(item.url)" />
            </div>
            <!-- <div class="text-size">{{ $t('请通过') }} neco.ltd@outlook.com {{ $t('与我们联系') }}</div> -->
            <div class="text-size">{{ $t('联系') }}: neco.ltd@outlook.com</div>
            <div class="text-size reserved"><span class="reserved-text">©</span> 2025 NECO DAO {{ $t('版权所有') }}</div>
        </div>
        <div class="text-size footer-right"><span class="reserved-text">©</span> 2025 NECO DAO {{ $t('版权所有') }}</div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                iconList: [
                    {
                        icon: require('../../../static/image/link/icon-TG.png'),
                        url: 'https://t.me/+F9RfnSqKCyBiN2M5'
                    },
                    {
                        icon: require('../../../static/image/link/icon-TWITTER.png'),
                        url: 'https://x.com/Neco_Dapp'
                    },
                    {
                        icon: require('../../../static/image/link/icon-google.png'),
                        url: 'https://drive.google.com/drive/folders/19K36cmSSb4NsBrdGCwjbcyLCS3GI2xKN'
                    },
                    // {
                    //     icon: require('../../../static/image/link/icon-robot.png'),
                    //     url: 'https://poe.com/NECO-Web3-V1.3.3'
                    // },
                ]
            }
        },
        methods: {
            openLink(url) {
                if (url) {
                    window.open(url);
                }
            }
        }
    }
</script>
<style scoped>
.footer{
    box-sizing: border-box;
    position: absolute;
    bottom: 20px;
    left: 0;
    width: 100%;
    padding: 0 2.18rem;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    color: #fff;
    z-index: 1;
    font-size: 16px;
    color: #fff;
}
.footer-left {
    /* display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start; */
}
.text-size {
    font-size: 14px;
}
.img-box {
    padding-bottom: 10px;
}
.footer-left img {
    width: 42px;
    height: 42px;
    background: #FFFFFF1A;
    margin-right: 10px;
    border-radius: 50%;
}
.footer-left img:hover {
    background: #FFFFFF33;
}
.footer-right {
    display: flex;
    align-items: center;
}
.reserved {
    padding-top: 10px;
    display: none;
}
.reserved-text {
    font-size: 20px;
    margin-right: 4px;
    margin-top: 4px;
}
@media screen and (max-width: 768px) {
    .footer {
        padding: 0 20px;
    }
    .footer-right {
        display: none;
    }
    .reserved {
        display: block;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/public/footer.vue